import React, { useState, useMemo, useCallback } from 'react';
import { TreeSelect, Spin } from 'antd';
import { connect } from 'react-redux';
import { tagsOnPartsRestCrudThunksForSupplier } from '../../thunks/tags_thunks';
import TagDisplay from '../TagDisplay';
import { Tag } from '../../types/tags';
import useMountEffect from '../../hooks/useMountEffect';

const { SHOW_PARENT } = TreeSelect;

const TagsDropdown = ({
	value,
	onChange,
	mode,
	allowClear = true,
	style,
	placeholder,
	disabled,
	tagRender,
	tags,
	fetchAllTags,
}) => {
	const [allTags, setAllTags] = useState<Tag[]>([]);
	const [fetched, setFetched] = useState(false);

	useMountEffect(() => {
		fetchAllTags().then((result) => {
			setAllTags(result);
			setFetched(true);
		});
	});

	const treeData = useMemo(() => {
		const selectedIds = Array.isArray(value) ? value : value ? [value] : [];
		const selectedRecords = selectedIds
			.map((id) => tags.records[id])
			.filter((record) => record && record.id);

		const allRecordIds = new Set(allTags.map((tag) => tag.id));
		const merged = [
			...selectedRecords.filter((record) => !allRecordIds.has(record.id)),
			...allTags,
		];

		return merged.map((tag) => ({
			value: tag.id,
			key: tag.id,
			title: <TagDisplay tag={tag} />,
			filterText: tag.label || '',
		}));
	}, [allTags, value, tags.records]);

	const handleChange = useCallback(
		(selectedValues) => {
			if (onChange) {
				onChange(selectedValues);
			}
		},
		[onChange]
	);

	return (
		<TreeSelect
			virtual={false}
			multiple={mode === 'multiple'}
			treeCheckable={mode === 'multiple'}
			showCheckedStrategy={SHOW_PARENT}
			treeDefaultExpandAll
			notFoundContent={!fetched ? <Spin size="small" /> : null}
			placeholder={placeholder}
			showSearch
			treeNodeFilterProp="filterText"
			onChange={handleChange}
			treeData={treeData}
			style={style}
			allowClear={allowClear}
			value={value}
			disabled={disabled || (!fetched && treeData.length === 0)}
			tagRender={tagRender}
		/>
	);
};

const mapStateToProps = (state) => ({
	tags: state.tags,
});

const mapDispatchToProps = (dispatch) => ({
	fetchAllTags: () =>
		dispatch(
			tagsOnPartsRestCrudThunksForSupplier.readLite({ no_pagination: true }, 'tagsDropdown')
		),
});

export default connect(mapStateToProps, mapDispatchToProps)(TagsDropdown);
